export enum CategoryId {
    Animals = 'animals',
    Art = 'art',
    Car = 'car',
    Dinner = 'dinner',
    Fireworks = 'fireworks',
    Fly = 'fly',
    Health = 'health',
    Sport = 'sport',
    Surf = 'surf',
    Travel = 'travel',
    Tv = 'tv',
}
